export const getHeroImage = (media = []) => {
  const image = media.find(
    (item) =>
      item.label?.toLowerCase() === 'hero' && item?.media_type === 'image'
  );
  return image && image.url;
};
